module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"whyYou":"HVORFOR DU VIL ELSKE HVERDAGEN","whyBrain":"HVORFOR HJERNEN DIN VIL ELSKE DEG"},"en":{"whyYou":"HVORFOR DU VIL ELSKE HVERDAGEN","whyBrain":"HVORFOR HJERNEN DIN VIL ELSKE DEG"}}')
  delete Component.options._Ctor
}
